import React from 'react'
import { AttachmentLink, Heading } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { Block, BlockRow, Text } from '@pandiafi/components'

import { Section } from '../../../components'
import { FeedbackAndQuestionNoticeDetails } from '../../../../common/validations/feedbackAndQuestionNotice'
import { User } from '../../../../common/validations'

interface QuestionViewProps {
  existingNotice?: FeedbackAndQuestionNoticeDetails
  user: User
}

export const QuestionDetailView: React.FC<QuestionViewProps> = ({
  existingNotice,
  user,
}) => {
  const { t } = useTranslation(['common', 'question'])

  const { title, description, files } = existingNotice || {}

  return (
    <>
      <div className="bg-brand-1 py-8 rounded-t-lg -mt-7 -mx-7 mb-10 text-center">
        <Heading size="l" element="h1">
          {t('question:headings.questionDetail')}
        </Heading>
      </div>
      <Section className="mb-12">
        <Block>
          <BlockRow>
            <Text element="p">{user.email}</Text>
            <Text element="p">{user.phoneNumber}</Text>
          </BlockRow>
          <BlockRow>
            <Text element="h2" size="xl" weight="medium">
              {title}
            </Text>
          </BlockRow>
          <BlockRow>
            <Text element="p" className="hyphens-auto [overflow-wrap:anywhere]">
              {description}
            </Text>
          </BlockRow>
          {files && files.length > 0 && (
            <>
              <BlockRow>
                <Text element="h3" size="m" weight="medium">
                  {t('question:labels.files')}:
                </Text>
              </BlockRow>
              {files.map((file) => (
                <BlockRow key={file.uuid || file.fileName}>
                  <AttachmentLink
                    text={file.fileName || `${t('common:file')}`}
                    icon="paperclip"
                    disabled
                  />
                </BlockRow>
              ))}
            </>
          )}
        </Block>
      </Section>
    </>
  )
}
